var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
export var selectPermissionsDomain = function (state) {
    return (state === null || state === void 0 ? void 0 : state.permissions) || getInitialState();
};
export var selectPermissionsPermissionsDomain = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.permissions) === null || _a === void 0 ? void 0 : _a.permissions) || getInitialState().permissions; };
export var selectPermissionsLoadingState = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.permissions) === null || _a === void 0 ? void 0 : _a.loading) || getInitialState().loading; };
export var makeSelectPermissions = function () {
    return createSelector(selectPermissionsPermissionsDomain, function (permissionsState) { return permissionsState || {}; });
};
export var makeSelectSingleTargetPermissions = function (target) {
    return createSelector(selectPermissionsPermissionsDomain, function (permissionsState) { return permissionsState[target] || []; });
};
export var selectPermissions = makeSelectPermissions();
export var makeSelectIsLoading = function () {
    return createSelector(selectPermissionsDomain, function (domain) { return domain.loading; });
};
export var makeSelecteRolePermissionsRoleId = function () {
    return createSelector(selectPermissionsDomain, function (domain) { return domain.rolePermissionsRoleId; });
};
// Select app groups that don't have any permissions on this target to populate the new permission modal
export var makeSelectTargetNewGroups = function () {
    return createSelector(selectPermissionsDomain, function (_a) {
        var appGroups = _a.appGroups, targetPermissions = _a.targetPermissions, targetPermissionsNew = _a.targetPermissionsNew;
        // filter out groups already in the table
        return appGroups
            .filter(function (grp) {
            return targetPermissions.findIndex(function (perm) { return perm.groupId === grp.id; }) ===
                -1 &&
                targetPermissionsNew.findIndex(function (newPerm) { return newPerm.groupId === grp.id; }) === -1;
        })
            .map(function (group) { return (__assign(__assign({}, group), { label: group.id, groupLabel: group.label })); });
    });
};
export var makeSelectPermissionItems = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) {
        return permissionsDomain.permissionItems.map(function (it) { return (__assign(__assign({}, it), { targetStr: "".concat(it.target.scope, ":").concat(it.target.scopeId).concat(it.target.name ? ":".concat(it.target.name) : "") })); });
    });
};
export var makeSelectTargetPermissionsNew = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) { return permissionsDomain.targetPermissionsNew; });
};
// Apply `targetPermissionPatches` and append `targetPermissionsNew` to the `targetPermissions`
// for diplaying permissions in the editable table
export var makeSelectTargetPermissions = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) {
        return permissionsDomain.targetPermissions
            .map(function (targetPermission) {
            var patchForGroup = permissionsDomain.targetPermissionPatches.find(function (patch) { return targetPermission.groupId === patch.groupId; });
            if (!patchForGroup)
                return targetPermission;
            return __assign(__assign(__assign(__assign(__assign(__assign({}, targetPermission), ('create' in patchForGroup && {
                create: patchForGroup.create === 'grant',
            })), ('read' in patchForGroup && {
                read: patchForGroup.read === 'grant',
            })), ('update' in patchForGroup && {
                update: patchForGroup.update === 'grant',
            })), ('delete' in patchForGroup && {
                delete: patchForGroup.delete === 'grant',
            })), ('permission' in patchForGroup && {
                permission: patchForGroup.permission === 'grant',
            }));
        })
            .concat(permissionsDomain.targetPermissionsNew);
    });
};
export var makeSelectTargetPermissionPatches = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) { return permissionsDomain.targetPermissionPatches; });
};
export var makeSelectPermissionRoles = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) { return permissionsDomain.permissionRoles; });
};
export var makeSelectPermissionRoleById = function (id) {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) { var _a; return (_a = permissionsDomain === null || permissionsDomain === void 0 ? void 0 : permissionsDomain.permissionRoles) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === id; }); });
};
// Apply `rolePermissionPatches` to the `targetPermissions` for diplaying permissions in the editable table
export var makeSelectRolePermissions = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) {
        return permissionsDomain.rolePermissions.map(function (rolePermission) {
            var patchForTarget = permissionsDomain.rolePermissionPatches.find(function (patch) {
                return rolePermission.target &&
                    rolePermission.target.scope === patch.target.scope &&
                    rolePermission.target.scopeId === patch.target.scopeId &&
                    rolePermission.target.name === patch.target.name;
            });
            var targetStr = "".concat(rolePermission.target.scope, ":").concat(rolePermission.target.scopeId).concat(rolePermission.target.name ? ":".concat(rolePermission.target.name) : "");
            if (!patchForTarget)
                return __assign(__assign({}, rolePermission), { targetStr: targetStr });
            return __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, rolePermission), { targetStr: targetStr }), ('create' in patchForTarget && {
                create: patchForTarget.create === 'grant',
            })), ('read' in patchForTarget && {
                read: patchForTarget.read === 'grant',
            })), ('update' in patchForTarget && {
                update: patchForTarget.update === 'grant',
            })), ('delete' in patchForTarget && {
                delete: patchForTarget.delete === 'grant',
            })), ('permission' in patchForTarget && {
                permission: patchForTarget.permission === 'grant',
            }));
        });
    });
};
export var makeSelectRolePermissionPatches = function () {
    return createSelector(selectPermissionsDomain, function (permissionsDomain) { return permissionsDomain.rolePermissionPatches; });
};
